(function() {
  const btn = document.querySelector('.direct-checkout-btn-price');
  if (!btn) return;

  const formatVariantPrice = (cents) => {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    const normalizedAmount = Number(cents || 0) / 100;
    return normalizedAmount.toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD'
    });
  };

  btn.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const variantId = this.dataset.variantId;
    const qtyInput = document.querySelector('input[name="quantity"]');
    const quantity = qtyInput ? qtyInput.value : 1;

    let checkoutUrl = '/checkout?updates[' + variantId + ']=' + quantity;

    const urlParams = new URLSearchParams(window.location.search);
    const discountCode = urlParams.get('discount') || urlParams.get('discount_code');

    if (discountCode) {
      checkoutUrl += '&discount=' + encodeURIComponent(discountCode);
    }

    window.location.href = checkoutUrl;
  });

  document.addEventListener('variant:change', function(event) {
    if (event.detail && event.detail.variant) {
      const v = event.detail.variant;
      btn.dataset.variantId = v.id;
      btn.disabled = !v.available;
      const textEl = btn.querySelector('.btn-price-atc__text');
      const sepEl = btn.querySelector('.btn-price-atc__separator');
      const priceEl = btn.querySelector('.btn-price-atc__price');
      const soldEl = btn.querySelector('.btn-price-atc__sold-out');
      if (v.available) {
        if (textEl) textEl.style.display = '';
        if (sepEl) sepEl.style.display = '';
        if (priceEl) { priceEl.style.display = ''; priceEl.innerHTML = formatVariantPrice(v.price); }
        if (soldEl) soldEl.style.display = 'none';
      } else {
        if (textEl) textEl.style.display = 'none';
        if (sepEl) sepEl.style.display = 'none';
        if (priceEl) priceEl.style.display = 'none';
        if (soldEl) soldEl.style.display = '';
      }
    }
  });
})();
